import createQueryHook from '@segment/utils/createQueryHook';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { fetchAllResources } from '../../../staticSiteBackend/resources';
export var createAllResourcesQuery = function createAllResourcesQuery(client) {
  return [["resources", "allResourcesQuery"], function () {
    return fetchAllResources(client);
  }];
};
export var useAllResourcesQuery = createQueryHook(createAllResourcesQuery, useStaticSiteBackend, {
  staleTime: Infinity
});